const cloudStorageConfig = import.meta.env.REACT_APP_CLOUD_STORAGE_CONFIG
  ? JSON.parse(import.meta.env.REACT_APP_CLOUD_STORAGE_CONFIG)
  : {};

type AppConfig = {
  // 靜態 theme 欄位：維持強型別
  showVersionBar: boolean;
  showActorList: boolean;
  reportMetric1Color: string;
  reportMetric2Color: string;
  loginBtnType: string;
  // 其餘一律 any：
  // - env 來源值（baseURL / googleMapsApiKey / shortenUrlLength…）：沿用原本 themeConfig
  //   `as any` 時期的寬鬆，避免既有「env 字串當 string/number 用」的程式報錯。
  // - theme / runtime（themeConfig.applyThemeConfig）動態加上的 key（如 mainPagePath…）。
  [key: string]: any;
};

const config: AppConfig = {
  showVersionBar: true,
  showActorList: true,
  reportMetric1Color: '#8884d8',
  reportMetric2Color: '#82ca9d',
  loginBtnType: 'primary',
  baseURL: import.meta.env.REACT_APP_WS_END_POINT,
  env: import.meta.env.REACT_APP_ENV,
  version: import.meta.env.REACT_APP_VERSION,
  cloudStorageConfig,
  shortenUrlLength: import.meta.env.REACT_APP_SHORTEN_URL_LENGTH,
  audienceSizeLowerBound: import.meta.env.REACT_APP_AUDIENCE_SIZE_LOWERBOUND,
  googleMapsApiKey: import.meta.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  picGoogleMapsApiKey: import.meta.env.REACT_APP_ENV?.endsWith('pic')
    ? import.meta.env.REACT_APP_GOOGLE_MAPS_API_KEY
    : import.meta.env.REACT_APP_PIC_GOOGLE_MAPS_API_KEY,
  googleMapsId: import.meta.env.REACT_APP_GOOGLE_MAPS_ID,
  tenmaxLineDomain: import.meta.env.REACT_APP_TENMAX_LINE_DOMAIN
};

export default config;
